import { create } from 'zustand';
const useLangStore = create((set) => ({
  lang: localStorage.getItem('vk_lang') || 'sw',
  setLang: (l) => { localStorage.setItem('vk_lang', l); set({ lang: l }); },
}));
export default useLangStore;
